<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-12-21_jouluinfo";
    let title = "Jouluinfo!";
    let titlePic = "/svelte-site/img/ajankohtaista/pukit-jumppaa.jpg";
    let firstPara = "Joulun aukioloajat | Vanhentuvat liikuntasetelit | Alvimuutos vuodelle 2025 | Uusi ryhmätunti viikkoon.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h1>{title}</h1>
                    <b>Joulun aukioloajat ja 2025 treeni</b>
                    <p>

                        Joulun aikana rauhoitumme juhlan viettoon. Viimeinen ryhmätreeni (Savotta) pidetään lauantaina
                        21.12. Kulkuavaimella pääsee toki treenailemaan joulutauollakin normaaliin tapaan vaikka joka
                        päivä.</p>
                    <p>
                        Yhteistreenien makuun pääsemme rytinällä taas, kun lauantaina 28.12. juhlistamme vuoden
                        vaihtumista odotetulla 2025 treenillä (klo 11 alkaen)! Tähän kuntoiluun kannattaa varata vähän
                        tavallista enemmän aikaa. Perinteitä kunnioittaen treenissä tehdään 2025 toistoa eri liikkeitä
                        :).</p>
                    <p>
                        Maanantaina 30.12. pidetään vain SykeKaski klo 18. Uudenvuodenaattona ei ole Savottaa.
                        Normaaliin aikatauluun palaamme 2.1. Kasken merkeissä klo 18 ja 19.</p>
                    <p>Tässä vielä joulunajan treenit:</p>
                    <ul>
                        <li>La 21.12. Savotta</li>
                        <li>La 28.12. “2025”</li>
                        <li>Ma 30.12. SykeKaski klo 18</li>
                        <li>To 2.1. jatkuu normaalilla aikataululla</li>
                    </ul>
                    <b>Uusi tunti viikkoon!</b>
                    <p>
                        Suuren kysynnän vuoksi päätimme lisätä uuden SykeKasken tiistai-iltaan klo 19 heti Savotan
                        jälkeen. Ensimmäinen uuden viikko-ohjelman mukainen treeni starttaa tiistaina 7.1. ja jatkuu
                        ainakin kevään 2025 ajan. Treenin kesto on Kaski-treeneille tuttu 45 minuuttia.
                    </p>
                    <b>Alvimuutos</b>
                    <p>

                        Veroprosentit ja yleisesti kustannukset ovat nousseet kuluneen vuoden aikana. Vuoden vaihteessa
                        verotus nousee alennetun arvonlisäveroprosentin palvelujen osalta, joihin myös liikuntapalvelut
                        kuuluvat. Näiden myötä mekin joudumme tarkistamaan hintojamme.
                    </p>
                    <b>Uudet hinnat 1.1.2025 alkaen:</b>
                    <ul>

                        <li>Päiväjäsenyys: 20 €</li>
                        <li>Omatoimijäsenyys: 30 €</li>
                        <li>Täysjäsenyys: 49 €</li>
                        <li>10x kortti: 67 €</li>
                        <li>Kertakäynti: 9 €</li>
                    </ul>
                    <p>
                        Tämän vuoden puolella lähtevät jäsenlaskut lähtevät vielä vanhalla hinnalla. Jäsenkuukausia ja
                        sarjakortteja on mahdollista ostaa etukäteen tämän vuoden puolella vielä vanhalla hinnalla.
                    </p>
                    <b>Vanhentuvat liikuntasetelit</b>
                    <p>

                        Nippu liikuntaetuja vanhenee taas vuoden vaihtuessa. Muista käyttää ne ajoissa. Nyt kannattaa
                        siis ostaa ennakkoon jäsenkuukausia, saat ne vielä vanhaan hintaan *wink wink.
                    </p>
                    <p>
                        Ostaminen onnistuu etänä tai ihan paikanpäällä käyden. Mikäli et joulun päivystyaikoina pääse
                        paikalle, ole rohkeasti yhteydessä joko puhelimella, sähköpostilla tai facebookissa. Saamme
                        kyllä homman jotenkin sumplittua.
                    </p>
                    <b>Käsiseisonta & Liikkuvuus -työpajat Dynamosalilla 16.2.2025</b>
                    <p>
                        Haluatko oppia käsilläseisonnan ilman aiempaa kokemusta tai löytää balanssia käsien päällä? Nita
                        Lehto tulee jälleen salillemme pitämään käsilläseisontatyöpajaa helmikuussa. Nyt on sinullakin
                        mahdollisuus saada harvinaislaatuista opetusta käsilläseisontaan ja liikkuvuusharjoitteluun
                        ammattitason valmentajalta.</p>
                    <p>
                        Kurssilla on 100% rahat takaisin takuu, jos koet, ettei workshop ollut rahojesi arvoinen.
                        Huhujen mukaan kaikki osaavat seisoa käsillään tämän jälkeen!
                    </p>
                    <ul>
                        <li>Käsiseisontatyöpaja klo 12.00-14.00 (49 €)</li>
                        <li>Liikkuvuustyöpaja. klo 14.15-15.15 (29 €)</li>
                        <li> Molemmat workshopit yhteishintaan vain 59 € !</li>
                    </ul>
                    <p>
                        Molemmat työpajat sisältävät myös treeniohjeet kotiin.
                        Ilmoittaudu mukaan / kysy lisää<br>
                        info@nitsku.fi </p>

                    <p>
                        Lisätietoja tapahtumista: <a target="_blank" href="https://fb.me/e/47KHm4ESw"> https://fb.me/e/47KHm4ESw </a>
                    </p>

                    <b>Joulunajan rempat</b>

                    <p>
                        Olemme aikomuksissa tehdä vähän tuunauksia Dynamon eteiseen tässä joulun aikana. Älkää siis
                        säikähtäkö, mikäli salille tullessasi eteisessä on vähän työkalut levällään. Sali on silti auki,
                        mutta remppaääniä voi kuulua ja työmiehen hymyjä näkyä siinä touhuilun lomassa.
                    </p>

                    <br>
                    Oikein hyvää joulua toivottaa
                    <br>
                    Dynamon koutsit
                </div>
                <div class="col-xs-12 col-md-6">
                    <img src="/svelte-site/img/ajankohtaista/pukit-jumppaa.jpg"/>
                </div>
            </div>


        </article>
    </div>
{/if}
